import React from 'react';
import { Link } from 'react-router-dom';
// No need to import User type if only using placeholder badges for now
// import { User } from '../../services/userService';

interface AchievementBadgesProps {
    // Badges are currently passed as placeholders from parent
    badges: any[]; // Keep as any[] until real badge data structure is defined/fetched
}

// Placeholder icons (replace with FontAwesome or similar later)
const icons: { [key: string]: string } = {
    "fas fa-brain": "🧠",
    "fas fa-chart-pie": "🥧",
    "fas fa-users": "👥",
    "fas fa-award": "🏆", // For empty state
    "fas fa-star": "⭐" // For button
};

const AchievementBadges: React.FC<AchievementBadgesProps> = ({ badges }) => {
    const hasBadges = badges && badges.length > 0;

    // Helper functions for dynamic styles
    const getBackgroundColor = (color: string) => `rgba(${color}, 0.1)`;
    const getIconColor = (color: string) => `rgb(${color})`;

    return (
        <div className="card border-0 shadow-sm mb-4">
            <div className="card-header bg-white py-3">
                <h5 className="mb-0 fw-bold">Achievement Badges</h5>
            </div>
            <div className="card-body p-4">
                {hasBadges ? (
                    <div className="row row-cols-2 row-cols-md-4 g-3">
                        {badges.map((badge) => (
                            <div key={badge.id} className="col text-center">
                                <div 
                                    className="badge-item p-2 rounded-3 h-100 d-flex flex-column align-items-center justify-content-center"
                                    title={badge.description}
                                >
                                    {/* Icon container */}
                                    <div 
                                        className="rounded-circle p-3 mb-2 d-flex align-items-center justify-content-center"
                                        style={{
                                            backgroundColor: getBackgroundColor(badge.color),
                                            width: '70px',
                                            height: '70px'
                                        }}
                                    >
                                        {/* TODO: Replace with actual icon component */}
                                        <span style={{ fontSize: '1.75rem', color: getIconColor(badge.color) }}>
                                            {icons[badge.icon] || '?'}
                                        </span>
                                    </div>
                                    {/* Badge details */}
                                    <h6 className="badge-title mb-1 fw-bold">{badge.title}</h6>
                                    <p className="small text-muted mb-0">{badge.earned_date}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    // Empty State Content
                    <div className="text-center py-3">
                        <div className="mb-3">
                            {/* TODO: Replace with actual icon component */}
                            <span style={{ fontSize: '3rem' }} className="text-muted">{icons['fas fa-award']}</span>
                        </div>
                        <h6 className="mb-2">No badges yet</h6>
                        <p className="text-muted small mb-3">Complete activities and contribute to the DataNest community to earn badges</p>
                        {/* Use Link component if this navigates internally */}
                        <Link to="/achievements" className="btn btn-primary rounded-pill">
                            {/* TODO: Replace with actual icon component */}
                            <span className="me-2">{icons['fas fa-star']}</span> Explore Achievements
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AchievementBadges; 